export const Asset = (props) => {
  if (props.isVideo) {
    return <video className="video" src={props.src} autoPlay muted loop />;
  }
  return <img alt={props.name} className="photo" src={props.src}></img>;
};
